import React from 'react';
export function Guarantee() {
  return <section className="bg-navy-800 px-5 py-16 sm:py-20" data-id="element-104" data-mp="1qac7xuu2siv8">
      <div className="mx-auto max-w-2xl rounded-2xl border-2 border-gold/60 bg-white px-7 py-12 text-center" data-id="element-105" data-mp="1o4eyqj28j49x">
        <span aria-hidden="true" className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-gold/15 text-3xl" data-id="element-106" data-mp="222dcbm8qewod">
          🛡️
        </span>
        <h2 className="mt-6 font-display text-3xl font-black text-navy-800 sm:text-4xl" data-id="element-107" data-mp="19dzcr21zvsap">
          Zero Risk. <span className="text-gold-dark" data-id="element-108" data-mp="14gfn75zujt3g">7-Day Guarantee.</span>
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-base leading-relaxed text-slate-600" data-id="element-109" data-mp="1j4ah2pplc3i4">
          Open everything. Check every session. Use the drills. Try Cricket
          Ready risk-free. If you're not fully satisfied, we'll refund you 100%
          — no questions asked.
        </p>
        <p className="mt-7 inline-flex rounded-full bg-grass/10 px-4 py-2 text-xs font-bold uppercase tracking-[0.16em] text-grass-dark" data-id="element-110" data-mp="lp6citecayaa">
          Refund rate below 1%
        </p>
      </div>
    </section>;
}